<template>
	<div class="signBox">
		<!--头部-->
		<XDheader></XDheader>
		<div class="container">
			<img src="https://scdn.xidong360.com/longhu-marathon/2019/0816/menu/banner.png" alt />
			<h5>当前的位置是{{title}}</h5>
			<!--内容-->
			<div class="row">
				<div class="cc col-md-8">
					<div class="content_title">
						<span class="themes_menu_wrap_1">{{title}}</span>
					</div>
					<!-- 查询信息的表单 -->
					<div class="content_form themes_menu_wrap_1">
						<ul class="new-ctx-width clearfix">
							<li>
								<p>证件号码</p>
								<label>
									<input type="text" id="id_card" name="certificate" v-model="info.ID" placeholder="输入证件号码" />
								</label>
							</li>
							<li>
								<p>证件姓名</p>
								<label>
									<input type="text" id="real_name" name="name" v-model="info.name" placeholder="输入姓名" />
								</label>
							</li>
							<li
								@click="submit()"
								v-loading.fullscreen.lock="fullscreenLoading"
								class="select"
							>
								<span
									id="submit-btn"
								>
									<img
										style="width: 50%;"
										src="https://scdn.xidong360.com/longhu-marathon/2019/0816/menu/select-button.png"
									/>
								</span>
							</li>
						</ul>
					</div>
					<!-- 未查询到信息 -->
					<div class="search_none" style="text-align:center;display:none;">
						<img
							src="https://scdn.xidong360.com/longhu-marathon/2019/0816/search_none.svg"
							alt
							style="margin: 50px auto 30px;width:100px;"
						/>
						<div>
							<p style="font-size: 22px">抱歉, 未查询到您的报名信息</p>
							<span style="font-size: 22px">请检查输入信息是否有误, 如有问题请联系赛事主办方。</span>
						</div>
					</div>
					<!-- 查询到的信息 -->
					<div class="search_result">
						<ul>
							<li>
								<span>查询结果</span>
							</li>
							<li>
								<p>证件号码</p>
								<label>{{queryinfo.certificate}}</label>
							</li>
							<li>
								<p>证件姓名</p>
								<label>{{queryinfo.name}}</label>
							</li>
							<li>
								<p>参赛组别</p>
								<label>{{queryinfo.groupName}}</label>
							</li>
							<li>
								<p>参赛号码</p>
								<label>{{queryinfo.number||'-'}}</label>
							</li>
							<!-- <li>
								<p>报名状态</p>
								<label>报名成功</label>
								<label>未支付</label>
							</li>-->
						</ul>
					</div>
				</div>
				<div class="col-md-4">
					<XDright></XDright>
				</div>
			</div>
		</div>
		<!--底部-->
		<XDfooter></XDfooter>
	</div>
</template>
<script>
import api from "@/axios";
import { mapState, mapGetters } from "vuex";
export default {
	name: "signquery",
	data() {
		return {
			route: this.$route.path,
			title: "",
			info: {
				ID: "",
				name: "",
				path: ""
			},
			queryinfo: {},
			fullscreenLoading: false
		};
	},
	mounted() {
		this.getpath();
		this.getEquipment()
	},
	watch: {},
	methods: {
		gotopath(path) {
			this.$router.push({ path });
		},
		getpath() {
			let arr = this.route.split("/");
			arr.forEach(item => {
				if (item == "scorequery") {
					this.title = "成绩查询";
					this.info.path = item;
				} else if (item == "signquery") {
					this.title = "报名查询";
					this.info.path = item;
				}
			});
		},
		// 提交查询信息
		submit() {
			if (!this.info.ID || !this.info.name) {
        this.$alert('请输入有效的查询信息', '提示', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
			} else {
				this.select();
			}
		},
		showloading() {
			this.fullscreenLoading = true;
		},
		hideloading() {
			this.fullscreenLoading = false;
		},
		select() {
			// 接口名称需要改
			this.showloading();
			api
				.getsigninfo({
					certificate: this.info.ID,
					name: this.info.name,
					gameId: this.gameId
				})
				.then(({ data }) => {
					this.hideloading();
					if (data.code === 0) {
						if (data.data) {
							$(".search_result").css("display", "block");
							$(".search_none").css("display", "none");
							this.queryinfo = data.data;
						} else {
							$(".search_none").css("display", "block");
							$(".search_result").css("display", "none");
						}
					} else {
						$(".search_none").css("display", "block");
						$(".search_result").css("display", "none");
					}
				});
		},
		getEquipment(){
			let agent=navigator.userAgent
			if(agent.indexOf('Windows ')==-1){
				$('.content_form ul li:eq(2)').addClass("selectA");
				// $('.selectA').css("padding-top",'45px');
				$('.content_form ul').addClass("newul");
				console.log('移动端');
			}else{
		
			}
		}
	},
	computed: {
		...mapState(["gameId"])
	}
};
</script>
<style scoped>
@import "../../assets/themes/signquery.css";
.selectA span{
	height:60px;
	width: 100px;	
	position: relative;
}
.selectA img{
	width: 70%;
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%,-50%)
}
.content_form .newul label input{
	width: 130px;
	height: 40px;
}
.content_form .newul{
	padding-top: 30px;
	padding-left: 20px;
	padding-right: 20px;
}
.content_form ul{
	padding-left: 20px;
	padding-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/template/sign/signquery.vue